export const SEGMENTS = [
  '0',      'x4',    'x5',  'x2',  'x10', '1 spin',
  'x2',     'x4',    'x20', 'Jackpot', 'x5', 'x4',
  'x10','2 spin','x2',  'x4',  'x40', 'x5',
  'x10','x2',    'x4',  'x20', '4 spin', 'x5',
];

// export const EMPTY_BETS = () => ({ x2: 0, x4: 0, x5: 0, x10: 0, x20: 0, x40: 0 });
export const EMPTY_BETS = () => ({
  x2: {},
  x4: {},
  x5: {},
  x10: {},
  x20: {},
  x40: {}
});

export const COLORS = [
  '#E74C3C',
  '#3498DB',
  '#2ECC71',
  '#F1C40F',
  '#9B59B6',
  '#E67E22',
];

export const PRIZE_ACCENT = {
  'x40':    '#FFD700',
  'x20':    '#FF6B9D',
  '1 spin': '#00E5FF',
  '2 spin': '#00FF99',
  '4 spin': '#FF44AA',
  '0':      '#BABABA',
  'Jackpot': '#FFD700',
};

export const NUM_SEG    = 24;
export const SEG_DEG    = 360 / NUM_SEG;
export const DEG2RAD    = Math.PI / 180;

export const TITLE_COLORS = [
  '#FF4444','#FFD700','#44FF44','#44AAFF','#fff','#FF44AA',
  '#FFD700','#44FF44','#fff','#FF4444','#FFD700','#44AAFF',
];

export const LEFT_BETS = [
  { label: 'x2',  grad: 'linear-gradient(180deg,#EEE050,#C8A800)', dark: '#907000' },
  { label: 'x4',  grad: 'linear-gradient(180deg,#A870E0,#6A30B8)', dark: '#4A1890' },
  { label: 'x5',  grad: 'linear-gradient(180deg,#E87040,#C03810)', dark: '#8A2800' },
];

export const RIGHT_BETS = [
  { label: 'x10', grad: 'linear-gradient(180deg,#50D870,#18943A)', dark: '#0D6228' },
  { label: 'x20', grad: 'linear-gradient(180deg,#E070CC,#A83898)', dark: '#782068' },
  { label: 'x40', grad: 'linear-gradient(180deg,#C8D0D8,#8090A0)', dark: '#506070' },
];

export const COINS = [
  { value: 100,  color: '#C82828', stripe: '#FFFFFF' },
  { value: 50,   color: '#1A9A30', stripe: '#FFFFFF' },
  { value: 25,   color: '#6820B0', stripe: '#FFFFFF' },
  { value: 15,   color: '#D06010', stripe: '#FFFFFF' },
  { value: 10,   color: '#18A090', stripe: '#FFFFFF' },
  { value: 5,    color: '#5878C0', stripe: '#FFFFFF' },
  { value: 1,    color: '#C04060', stripe: '#FFD700' },
  { value: 0.5,  color: '#A07010', stripe: '#FFFFFF' },
];

export const MAX_BET_PER_BOX = 100;
